import { initHmbMenu, menuAccordion } from './modules/hamburger-menu';
import { initTop } from './pages/top';
import { initCustomArchive, initInterviewArchive } from './pages/archive';
import { initPageTopics,initKeywords } from './pages/page';
import { initHeader } from './modules/header';
import { initPageTop } from './modules/page-top';

document.addEventListener('DOMContentLoaded', () => {
    // initHeader();
    initHmbMenu();
    menuAccordion();
    initPageTop('js-pagetop')
    const pageId = document.querySelector('body').getAttribute('data-pageid');

    switch (pageId) {
        case 'top':
            initTop();
            break;
        case 'archive':
            initInterviewArchive();
            break;
        case 'column-archive':
            initCustomArchive();
            break
        case 'page-topics':
            initPageTopics();
            break;
        case 'page-keywords':
            initKeywords();
            break;
        default:
            break;
    }
});